"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateDecisionDTO = void 0;
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const ProjectCandidateDecision_1 = require("../entity/ProjectCandidateDecision");
const RequestCommentDTO_1 = require("./RequestCommentDTO");
class CandidateDecisionDTO {
}
exports.CandidateDecisionDTO = CandidateDecisionDTO;
__decorate([
    (0, class_validator_1.IsIn)(ProjectCandidateDecision_1.DecisionStatusNames),
    __metadata("design:type", String)
], CandidateDecisionDTO.prototype, "status", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => RequestCommentDTO_1.RequestCommentDTO),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.ValidateNested)(),
    __metadata("design:type", RequestCommentDTO_1.RequestCommentDTO)
], CandidateDecisionDTO.prototype, "comment", void 0);
